import * as angular from 'angular';
import { IDataBackupRestoreService, IDataBackupConfiguration, IDateRangeService } from '../../services';
import { BackupMetadata, ComponentDefinition } from '../../models';

class DataBackupController implements angular.IComponentController {
    config: IDataBackupConfiguration;
    isLoading: boolean;
    loadingMessage: string;
    metadata: BackupMetadata;
    initialRange: IDataBackupConfiguration;
    isRefreshPrevented: boolean = true;

    static $inject = ['$scope', 'dataBackupRestoreService', 'dateRangeService'];

    constructor(private _$scope: angular.IScope,
        private _dataBackupRestoreService: IDataBackupRestoreService,
        private _dateRangeService: IDateRangeService) {

        this._$scope.$watchGroup(
            [() => this._dateRangeService.beginDate() as string, () => this._dateRangeService.endDate() as string],
            () => this.resetDate()
        );
    }

    $onInit() {
        if (!this.config) {
            this.config = {};
        }
        this.resetDate();
    }

    downloadData() {
        this.loadingMessage = 'Exporting data';
        this.isLoading = true;
        this._dataBackupRestoreService
            .backup(this.config.beginDate, this.config.endDate, this.config.includeModel, this.config.includeLogs)
            .then(data => this.metadata = data)
            .finally(() => this.isLoading = false);
    }

    private resetDate() {
        if (this._dateRangeService.initialized()) {
            this.config.beginDate = this._dateRangeService.beginDate() as string;
            this.config.endDate = this._dateRangeService.endDate() as string;
        } else {
            const yesterday = new Date();
            yesterday.setHours(yesterday.getHours() - 1);
            this.config.beginDate = yesterday.toISOString();
            this.config.endDate = new Date().toISOString();
        }
        this.initialRange = this.config;
    }
}

export const wtDataBackup: ComponentDefinition = {
    componentId: 'wtDataBackup',
    controller: DataBackupController,
    controllerAs: 'vm',
    template: require('./dataBackup.component.html'),
    bindings: {
        isLoading: '=',
        loadingMessage: '=',
        config: '=?',
    }
};